/* @ngInject */
export default function NonDev($compileProvider, $stickyStateProvider) {
  // $stickyStateProvider.enableDebug(false);

  $compileProvider.debugInfoEnabled(false);
  // use angular.reloadWithDebugInfo(); for debugging
}
